import {ApiAction} from 'redux-upgrader';

export const GET_DASHBOARD = new ApiAction('GET_DASHBOARD');
